<template>
  <div class="card card-modern">
    <div class="card-header">
      <div class="card-actions">
        <a
          class="card-action card-action-toggle"
          href="#orders-by-locations"
          data-bs-toggle="collapse"
        />
      </div>
      <h2 class="card-title">Narudžbe po lokaciji</h2>
    </div>
    <div class="card-body show" id="orders-by-locations">
      <div v-for="item in dashboardData.customersByLocation" :key="item.townId">
        <label>{{ item.title }} ({{ item.numberOfCustomers }})</label>
        <div class="progress progress-xs mb-4 light rounded-0">
          <div class="progress-bar progress-bar-primary rounded-0" role="progressbar"
            :style="{ width: `${item.numberOfCustomers / dashboardData.totalOrdersCount * 100}%` }">
            <span class="sr-only">{{ item.numberOfCustomers / dashboardData.totalOrdersCount * 100 }}%</span>
          </div>
        </div>
      </div>

      <router-link
        :to="{ name: 'Orders' }"
        class="
          btn btn-light btn-xl
          border
          font-weight-semibold
          text-color-dark text-3
          mb-4
        "
      >
        Pogledaj sve
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrdersByLocation',
  computed: {
    dashboardData() {
      return this.$store.getters.getDashboardData;
    },
  },
};
</script>
